export type SupportedLanguages = 'fl' | 'nl' | 'en' | 'fr' | 'de' | 'it' | 'pl' | 'pt' | 'ro' | 'es' | 'tr';

export type TranslationKeys = { [key: string]: string };

export type LangJsonFile = {
    [key in SupportedLanguages]?: TranslationKeys;
};

export class ReactTranslation {
    resources: LangJsonFile = {};
    showKey = false;

    public get(lang: SupportedLanguages) {
        return {
            ...this.resources['en'],
            ...this.resources[lang],
        };
    }

    public initResources(resources: LangJsonFile) {
        this.resources = resources;
    }

    public addResources(lang: LangJsonFile) {
        Object.entries(lang).forEach(([lang, translationKeys]) => {
            this.resources[lang as SupportedLanguages] = {
                ...translationKeys,
                ...this.resources[lang as SupportedLanguages],
            };
        });
    }
}

const Translation = new ReactTranslation();
export { Translation };
